import { render, staticRenderFns } from "./StepProgress.vue?vue&type=template&id=04dd7fc2&lang=pug&"
import script from "./StepProgress.vue?vue&type=script&lang=js&"
export * from "./StepProgress.vue?vue&type=script&lang=js&"
import style0 from "./StepProgress.vue?vue&type=style&index=0&id=04dd7fc2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports